/**
 * @generated SignedSource<<f5701b9ba61d80bacee7ed1fb8ebe0eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobEventReserved_event$data = {
  readonly timestamp: any;
  readonly " $fragmentType": "JobEventReserved_event";
};
export type JobEventReserved_event$key = {
  readonly " $data"?: JobEventReserved_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobEventReserved_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventReserved_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node as any).hash = "c82f5bca23d76f298b1efe84c2ce2b8e";

export default node;
